import { JOBS_URL } from '@/utils/constants'

const INSPECTIONS = () => `${JOBS_URL}`
const INSPECTIONS_BY_ID = (id: string) => `${JOBS_URL}/${id}`
const INSPECTIONS_TASKS = () => `${JOBS_URL}/tasks`

export default {
  INSPECTIONS,
  INSPECTIONS_BY_ID,
  INSPECTIONS_TASKS
}
